export default "__VITE_ASSET__Mph67708__"